import React, { useEffect } from "react";
import { useSidebar } from "../../content/SidebarContent";
import PageHeader from "../../components/PageHeader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { activeIcon, deactiveIcon } from "../../assets/icons"; // ✅ Update path as needed
import { reqToGetSettingDetails, reqToTooglePlanManagement } from "../../redux/slices.js/plans/plansSlice";
import { notify } from "../../helpers/commonFunctions";

const FreeTrailManagement = () => {
  const { setIsSidebarOpen } = useSidebar();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const settingDetails = useSelector(
    (state) => state.plans.settingDetails
  );
  const trialManagementSetting = settingDetails?.find(
    (setting) => setting.name === "Trial management"
  );
  
  useEffect(() =>{
    dispatch(
        reqToGetSettingDetails({
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
  }, [])

  const handleToggle = () => {
    dispatch(
        reqToTooglePlanManagement({
        data: {
            id: trialManagementSetting?.id,
            action: trialManagementSetting?.value ? "OFF" : "ON"
        },
        onSuccess: (res) => {
            notify(res?.data?.message, "success")
            dispatch(
                reqToGetSettingDetails({
                onSuccess: () => {},
                onFailure: () => {},
              })
            );
        },
        onFailure: () => {},
      })
    );
  };

  return (
    <section className="dashboard-page main-layout-page main-layout h-[calc(100vh-50px)]">
      <div className="!p-0">
        <div className="main-layout-wrapper bg-white h-screen flex flex-col sticky z-1 top-0">
          <PageHeader
            title="Free Trial Management"
            description="Understand how plan assignment works during tenant sign-up"
            onOpenSidebar={() => setIsSidebarOpen(true)}
          />

          <div className="flex-1 right-sidebar h-full relative overflow-y-auto">
            <div className="right-sidebar-contend py-6 px-4 md:px-6 pb-10 h-full">
              <div className="bg-white rounded-md shadow-md p-6 space-y-6">
                
                {/* Toggle Button */}
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h3 className="text-p !font-semibold text-blue">
                      Enable Free Trial Plan Assignment
                    </h3>
                    <p className="text-sub_span !font-normal text-gray-600 pb-0">
                      When enabled, a default trial plan will be assigned during tenant registration.
                    </p>
                  </div>
                  <button
                    onClick={handleToggle}
                    className="w-[36px] h-[36px] flex-none flex items-center justify-center rounded-full border border-gray-300 hover:shadow transition"
                    title={trialManagementSetting?.value ? "Disable Plan Assignment" : "Enable Plan Assignment"}
                  >
                    {trialManagementSetting?.value ? activeIcon : deactiveIcon}
                  </button>
                </div>

                {/* Explanation Section */}
                <div className="space-y-5">
                  <h2 className="text-p !font-semibold text-blue">
                    What is Free Plan Management?
                  </h2>
                  <p className="text-gray-700 text-sub_span !font-normal">
                    Plan Management is a feature that allows your system to automatically assign a subscription plan to users during their sign-up process. This could be a Free Plan, a Trial Plan (e.g., Plus Trial), or any default plan defined by your organization.
                  </p>

                  <h3 className="text-p !font-semibold text-blue mt-6">
                    What happens when it’s enabled?
                  </h3>
                  <ul className="text-sub_span !font-normal pl-5 text-gray-700 space-y-2">
                    <li className="list-disc">Newly registered users will be automatically assigned a predefined plan.</li>
                    <li className="list-disc">This ensures users get immediate access to services or features tied to the plan.</li>
                    <li className="list-disc">You can customize which plan is assigned in the backend.</li>
                  </ul>

                  <h3 className="text-p !font-semibold text-blue mt-6">
                    What happens when it’s disabled?
                  </h3>
                  <ul className="text-sub_span !font-normal pl-5 text-gray-700 space-y-2">
  <li className="list-disc">Newly registered users will be assigned the default <strong>Volka Base Plan</strong>.</li>
  <li className="list-disc">This ensures basic access to the platform without a trial or premium features.</li>
  <li className="list-disc">This setup is ideal if you want to avoid trial expirations and offer a consistent free tier.</li>
</ul>


                  <div className="mt-8 flex justify-end">
                    <button
                      onClick={() => navigate(-1)}
                     className="skip-btn border-blue"
                    >
                      Back 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeTrailManagement;
